(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-carousel-independent"] && !Shopify.designMode) return;
  try {
    
(function() {
  const wrappers = document.querySelectorAll('[data-ilm-wrapper]');

  wrappers.forEach(wrapper => {
    const container = wrapper.parentElement;
    
    const multiplyLogos = () => {
      // 1. Get the original items (the ones added in the editor)
      const originalItems = Array.from(wrapper.querySelectorAll('.ilm-logo-item:not(.ilm-clone)'));
      
      if (originalItems.length === 0) return;

      // 2. Calculate the width of one set of logos
      // We measure the wrapper width which currently holds just the originals
      const originalSetWidth = wrapper.scrollWidth;
      const containerWidth = container.offsetWidth;

      // 3. STRATEGY: Fill the screen width first
      // If we have 1 logo (e.g. 100px) and screen is 1400px, we need ~14 copies just to fill it.
      // We clone the original items repeatedly until the wrapper is wider than the screen.
      let safetyCounter = 0;
      while (wrapper.scrollWidth < containerWidth && safetyCounter < 50) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('ilm-clone'); // Mark as generated
          wrapper.appendChild(clone);
        });
        safetyCounter++;
      }

      // 4. STRATEGY: Duplicate for the infinite loop
      // For the CSS animation (translateX -50%) to work seamlessly, 
      // we need the content to be exactly double the visible width.
      // We just filled the wrapper to be >= containerWidth.
      // Now we duplicate EVERYTHING currently in the wrapper to create the second half.
      const currentItems = Array.from(wrapper.children);
      currentItems.forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.add('ilm-clone'); 
        wrapper.appendChild(clone);
      });
    };

    // Run logic
    multiplyLogos();

    // Handle resize: clear clones and recalculate
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Remove all clones
        wrapper.querySelectorAll('.ilm-clone').forEach(c => c.remove());
        // Run logic again
        multiplyLogos();
      }, 250);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
